import React from 'react';
import Button from '@liquidweb-dev/undercurrent/Button';
import useLogin from 'modules/oidc/useLogin';

const SignInButton = () => {
	const login = useLogin();

	return (
		<Button onClick={login} variant="secondary">
			Sign in
		</Button>
	);
};

export default SignInButton;
